import { useMutation } from '@tanstack/react-query';
import { userDataQuery } from '../api/userDataQuery';
import { useUserStore } from '../model/store/useUserStore';

type Props = {
    onError?: () => void;
    onSuccess?: () => void;
};

export const useUserData = ({ onSuccess, onError }: Props = {}) => {
    const { setUserData, setIsUserDataLoading } = useUserStore();

    return useMutation({
        mutationFn: userDataQuery,
        onMutate: () => {
            setIsUserDataLoading(true);
        },
        onSuccess: (rawData) => {
            const responseUrl = rawData.request?.responseURL;

            if (responseUrl && responseUrl.includes('realms')) {
                window.location.href = responseUrl;

                return;
            }

            const data = rawData.data;

            setUserData(data);
            setIsUserDataLoading(false);

            onSuccess?.();
        },
        onError: (error) => {
            console.error('Ошибка подгрузки данных пользователя:', error);
            setIsUserDataLoading(false);

            onError?.();
        },
        retry: false,
    });
};
